var Marker = require('../../lib/markers/marker.js');
var Deletism = require('../../lib/markers/deletism.js');

module.exports = function() {
  var marker = new Marker();

  new Deletism(marker);
};
